var _defs, _rect, _rect2, _rect3, _text, _g, _g2, _text2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConverterCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 200,
    y1: 80,
    x2: 1400,
    y2: 920,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E5D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 100,
    y1: 240,
    x2: 1500,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFE",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC",
    stopOpacity: 0.94
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "button",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334155"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 30,
    y: 185,
    width: 1540,
    height: 745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    rx: 40,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 118,
    fill: "#111827"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 118,
    fill: "url(#button)",
    fillOpacity: 0.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 74,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 48,
    fontWeight: 700
  }, "Converter")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 28,
    width: 140,
    height: 58,
    rx: 29,
    fill: "#FFFFFF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("text", {
    x: 1062,
    y: 67,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 600
  }, "Units"), /*#__PURE__*/React.createElement("text", {
    x: 1220,
    y: 67,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 500
  }, "Currency"), /*#__PURE__*/React.createElement("text", {
    x: 1452,
    y: 67,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 500
  }, "Time"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 218,
    width: 1428,
    height: 600,
    rx: 38,
    fill: "url(#panel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.75,
    y: 218.75,
    width: 1426.5,
    height: 598.5,
    rx: 37.25,
    stroke: "#D7DEE8",
    strokeOpacity: 0.9,
    strokeWidth: 1.5
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 325,
    textAnchor: "middle",
    fill: "#101828",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 66,
    fontWeight: 700
  }, "Unit Conversion")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(744 364)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    rx: 24,
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 81L78 38",
    stroke: "#111827",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 57L56 24L88 56L55 89L23 57Z",
    stroke: "#111827",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 42L47 51",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 50L39 59",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 54L81 63",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 62L73 71",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 515)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#101828",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 600
  }, "Select measurement"), /*#__PURE__*/React.createElement("rect", {
    x: 635,
    y: -36,
    width: 665,
    height: 64,
    rx: 18,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.75,
    y: -35.25,
    width: 663.5,
    height: 62.5,
    rx: 17.25,
    stroke: "#CBD5E1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 7,
    fill: "#98A2B3",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 32,
    fontWeight: 600
  }, "Length"), /*#__PURE__*/React.createElement("path", {
    d: "M1238 -2L1255 15L1272 -2",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 622)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#101828",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 600
  }, "From"), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: -38,
    width: 210,
    height: 68,
    rx: 20,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.75,
    y: -37.25,
    width: 208.5,
    height: 66.5,
    rx: 19.25,
    stroke: "#CBD5E1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 7,
    textAnchor: "middle",
    fill: "#98A2B3",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 500
  }, "42"), /*#__PURE__*/React.createElement("rect", {
    x: 635,
    y: -38,
    width: 665,
    height: 68,
    rx: 20,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.75,
    y: -37.25,
    width: 663.5,
    height: 66.5,
    rx: 19.25,
    stroke: "#CBD5E1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 7,
    fill: "#98A2B3",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 32,
    fontWeight: 600
  }, "Kilometer"), /*#__PURE__*/React.createElement("path", {
    d: "M1238 -2L1255 15L1272 -2",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(800 722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -122,
    y: -34,
    width: 244,
    height: 68,
    rx: 22,
    fill: "url(#button)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "Convert"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(800 822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -20V32",
    stroke: "#667085",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26 8L0 36L26 8",
    stroke: "#667085",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 910)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fill: "#101828",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 600
  }, "To"), /*#__PURE__*/React.createElement("rect", {
    x: 635,
    y: -38,
    width: 665,
    height: 68,
    rx: 20,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.75,
    y: -37.25,
    width: 663.5,
    height: 66.5,
    rx: 19.25,
    stroke: "#CBD5E1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 7,
    fill: "#98A2B3",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 32,
    fontWeight: 600
  }, "Meter"), /*#__PURE__*/React.createElement("path", {
    d: "M1238 -2L1255 15L1272 -2",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverterCover);
export default __webpack_public_path__ + "static/media/converter-cover.75f9a375822df78cae39a1c8b1e09e44.svg";
export { ForwardRef as ReactComponent };